import React, { useRef } from 'react';
import data from '../data.json';

function ServiceCard({ service }) {
  return (
    <div style={{
      width: 295, flexShrink: 0,
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius)',
      overflow: 'hidden',
      transition: 'all var(--ease)',
      cursor: 'default',
    }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-6px)';
        e.currentTarget.style.borderColor = 'rgba(255,107,43,0.35)';
        e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,107,43,0.08)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.borderColor = 'var(--border)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {/* Image */}
      <div style={{ height: 175, overflow: 'hidden', position: 'relative' }}>
        <img
          src={service.img}
          alt={service.title}
          loading="lazy"
          style={{
            width: '100%', height: '100%', objectFit: 'cover',
            filter: 'brightness(0.82) saturate(1.1)',
            transition: 'transform 0.5s ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.07)'; e.currentTarget.style.filter = 'brightness(0.95) saturate(1.2)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.filter = 'brightness(0.82) saturate(1.1)'; }}
        />
        {/* Gradient overlay */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to top, var(--bg-card) 0%, transparent 55%)',
        }} />
        {/* Icon badge */}
        <div style={{
          position: 'absolute', top: 12, left: 12,
          width: 38, height: 38, borderRadius: 9,
          background: 'rgba(6,6,15,0.78)', backdropFilter: 'blur(8px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 17, border: '1px solid rgba(255,255,255,0.1)',
        }}>
          {service.icon}
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: '18px 20px 22px' }}>
        <div style={{
          fontSize: '0.97rem', fontWeight: 800, color: '#fff',
          marginBottom: 7, letterSpacing: '-0.01em',
        }}>
          {service.title}
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--gray-400)', lineHeight: 1.7 }}>
          {service.description}
        </p>
        <div style={{
          display: 'inline-block', marginTop: 12,
          fontSize: 10, fontWeight: 800, letterSpacing: '1.2px',
          textTransform: 'uppercase', color: 'var(--accent)',
          padding: '3px 9px', borderRadius: 4,
          background: 'rgba(255,107,43,0.1)',
          border: '1px solid rgba(255,107,43,0.2)',
        }}>
          {service.tag}
        </div>
      </div>
    </div>
  );
}

export default function Services() {
  const trackRef = useRef(null);
  // Duplicate services for seamless infinite loop
  const doubled = [...data.services, ...data.services];

  const pause  = () => { if (trackRef.current) trackRef.current.style.animationPlayState = 'paused'; };
  const resume = () => { if (trackRef.current) trackRef.current.style.animationPlayState = 'running'; };

  return (
    <section id="services" style={{ padding: '110px 0 80px', position: 'relative', overflow: 'hidden' }}>

      {/* Subtle bg glow */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        background: 'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(255,107,43,0.04) 0%, transparent 70%)',
      }} />

      {/* Header */}
      <div className="container">
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'flex-end', marginBottom: 52,
          flexWrap: 'wrap', gap: 20,
        }}>
          <div>
            <div className="section-label">What We Do</div>
            <h2 className="section-title">Our Services</h2>
          </div>
          <p className="section-sub" style={{ maxWidth: 370, textAlign: 'right' }}>
            A full-stack digital arsenal — every growth service you need in one powerhouse agency.
          </p>
        </div>
      </div>

      {/* Carousel */}
      <div style={{
        position: 'relative', overflow: 'hidden',
        margin: '0 -28px', padding: '0 28px',
      }}>
        {/* Fade edges */}
        <div style={{
          position: 'absolute', top: 0, bottom: 0, left: 0, width: 100,
          background: 'linear-gradient(to right, var(--bg-deep), transparent)',
          zIndex: 10, pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', top: 0, bottom: 0, right: 0, width: 100,
          background: 'linear-gradient(to left, var(--bg-deep), transparent)',
          zIndex: 10, pointerEvents: 'none',
        }} />

        {/* Track */}
        <div
          ref={trackRef}
          onMouseEnter={pause}
          onMouseLeave={resume}
          style={{
            display: 'flex', gap: 22,
            animation: 'scrollLeft 45s linear infinite',
            width: 'max-content',
            willChange: 'transform',
          }}
        >
          {doubled.map((service, i) => (
            <ServiceCard key={`${service.id}-${i}`} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}
